import { FC, ReactNode } from 'react';

import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface BadgeProps {
  anchorOrigin: {
    horizontal: 'left' | 'right';
    vertical: 'bottom' | 'top';
  };
  backgroundColor?: string;
  content: ReactNode | string;
  fontColor?: string;
}

const Badge: FC<BadgeProps> = ({
  anchorOrigin,
  content,
  backgroundColor,
  fontColor,
}) => {
  const theme = useTheme();
  const { common } = theme.palette;

  return (
    <Typography
      variant="caption"
      sx={{
        position: 'absolute',
        [anchorOrigin.vertical]: '0.5rem',
        [anchorOrigin.horizontal]: '0.5rem',
        padding: '0 0.5rem',
        borderRadius: '3rem',
        color: fontColor ?? common.white,
        backgroundColor: backgroundColor ?? undefined,
        textTransform: 'capitalize',
      }}
    >
      {content}
    </Typography>
  );
};

export default Badge;
